import * as api from 'dashboard/resources/license-renewal.api';

@Inject('$window')
export class LinkToLicenseRenewalFormController {
  async redirectToLicensRenewalForm() {
    const url = await api.fetchLicenseRenewalFormLink(this.retailerId);

    this.$window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/components/link-to-license-renewal-form/link-to-license-renewal-form-controller.js